import React, { Component } from "react";
import Link from "gatsby-link";
import PropTypes from "prop-types";
import languageSwitcherStyle from "./languageSwitcher.module.pcss";

const LanguageSwitcher = ({currentLanguage}) => {

  const isActive = (language) => {
    return currentLanguage === language ? languageSwitcherStyle.active : null
  };

  return (
    <ul className={languageSwitcherStyle.languageSwitcher}>
      <li>
        <Link className={isActive("de")} to="/">de</Link>
      </li>
      <li>
        <Link className={isActive("en")} to="/en">en</Link>
      </li>
    </ul>
  );
};

LanguageSwitcher.propTypes = {
  currentLanguage: PropTypes.string.isRequired
};

export default LanguageSwitcher;



// WEBPACK FOOTER //
// ./src/components/languageSwitcher/languageSwitcher.js